import AuthLayout from "../../components/Auth/AuthLayout";
import AuthForm from "../../components/Auth/AuthForm";

const RegisterPage = () => {
  return (
    <AuthLayout>
      <AuthForm type="register" />
    </AuthLayout>
  );
};

export default RegisterPage;
